import type { RouteRecordRaw } from "vue-router"

export const GenericDecisionRoutesChildren: RouteRecordRaw[] = [
  {
    name: "generic-apply-nooffer",
    path: "nooffer",
    component: () => import("./components/GenericNoOffer.vue"),
  },
]

export const GenericDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "generic-decision-routes",
    path: "decision",
    component: () => import("./pages/GenericDecisionPage.vue"),
    children: GenericDecisionRoutesChildren,
  },
]
